var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListaUsuario(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 131,
    viewBox: "0 0 136 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_843_511)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8262 70.4762L27.5185 79.2158L44.9032 61.7366M18.8262 111.261L27.5185 120.001L44.9032 102.521M65.1854 70.4762H128.929M65.1854 111.261H128.929M65.1854 29.6914H128.929",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 40.2857V47H25.3684V40.2857C25.3684 40.2857 25.3684 26.8571 43.6842 26.8571C62 26.8571 62 40.2857 62 40.2857ZM52.8421 10.0714C52.8421 8.07949 52.305 6.13228 51.2987 4.47605C50.2924 2.81981 48.8622 1.52893 47.1888 0.766646C45.5154 0.00436383 43.6741 -0.195084 41.8976 0.193524C40.1211 0.582132 38.4894 1.54134 37.2086 2.94986C35.9278 4.35837 35.0556 6.15293 34.7023 8.10659C34.3489 10.0603 34.5303 12.0853 35.2234 13.9256C35.9166 15.7659 37.0903 17.3389 38.5964 18.4455C40.1024 19.5522 41.8729 20.1429 43.6842 20.1429C46.113 20.1429 48.4424 19.0818 50.1598 17.193C51.8773 15.3042 52.8421 12.7425 52.8421 10.0714ZM28.4211 16.7857H19.2632V6.71429H13.1579V16.7857H4V23.5H13.1579V33.5714H19.2632V23.5H28.4211V16.7857Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_843_511",
    x: 0,
    y: 0,
    width: 135.93,
    height: 131.001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_843_511"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_843_511",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListaUsuario);
export default __webpack_public_path__ + "static/media/listaUsuario.a5efb775644e9c910be77f11c9a01518.svg";
export { ForwardRef as ReactComponent };